import React from "react";
import Login from "./pages/auth/login";
import ForgotPassword from "./pages/auth/forget-password";
import ResendVerifyEmailPage from "./pages/auth/resend-verify-email";
import VerifyEmailPage from "./pages/auth/verify-email";
import VerifyAccountPage from "./pages/auth/verify-account";
import ResetPasswordPage from "./pages/auth/reset-password";
import TrackNTrace from "./pages/public-track-trace";
import AccountListingPageNew from "./pages/account-list/account-list-new";
import AccountCreate from "./pages/account-create/account-create";
import CustomerProfilePage from "./pages/customer-management/customer-profile";
import CustomerCreatePage from "./pages/customer-management/customer-create";
import CustomerEditPage from "./pages/customer-management/customer-edit";
import CustomerCreateSuccessPage from "./pages/customer-management/customer-create-success";
import DeletedCustomerProfilePage from "./pages/customer-management/deleted-customer-profile";
import CustomerLocationPage from "./pages/customer-management/customer-location";
import {
  ActiveDriverListingPage,
  InactiveDriverListingPage,
} from "./pages/new-driver-management/driver-listing";
import {
  DriverCreationPage,
  DriverCreationSuccessPage,
} from "./pages/new-driver-management/driver-create";
import { ExternalDriverCreationPage } from "./pages/new-driver-management/driver-create";
import { DriverUpdatePage } from "./pages/new-driver-management/driver-update";
import {
  ActiveUsersList,
  InactiveUsersList,
} from "./pages/user-management/users-listing";
import { UserUpdate } from "./pages/user-management/users-update";
import { UserCreationPage } from "./pages/user-management/user-create";
import { OrderProcessingSettings } from "./pages/order-management/settings";
import { OrderProcessingSettingsForm } from "./pages/order-management/settings-form";
import { OrderProcessingSettingsEditForm } from "./pages/order-management/settings-form-edit";
import { ParcelsOrder } from "./pages/order-management/order-processing/order-listing";
import { ParcelOrderCreationPage } from "./pages/order-management/order-processing/order-create";
import { UploadMassOrderPage } from "./pages/order-management/upload-mass-order";
import { ParcelOrderViewPage } from "./pages/order-management/order-processing/order-view";
import ParcelOrderEditPage from "./pages/order-management/order-processing/order-edit";
import { ReportOrders } from "./pages/order-management/report-orders";
import { CustomerOrderSetting } from "./pages/order-management/customer-setting";
import { CustomerOrderProcessingSettingsEditForm } from "./pages/order-management/order-processing/customer-settings-form-edit";
import {
  DeliveryAssetsFormPage,
  DeliveryAssetsListPage,
} from "./pages/delivery-management/delivery-assets";
import {
  DeliveryLinesListPage,
  DeliveryLinesFormPage,
} from "./pages/delivery-management/delivery-lines";
import {
  ServicePointsListPage,
  ServicePointsFormPage,
} from "./pages/delivery-management/service-points";
import { ParcelTracking } from "./pages/delivery-management/parcel-tracking/parcel-tracking-list";
import { ParcelTrackingPickupViewPage } from "./pages/delivery-management/parcel-tracking/parcel-tracking-view/pickup-view";
import { ParcelTrackingDropoffViewPage } from "./pages/delivery-management/parcel-tracking/parcel-tracking-view/dropoff-view";
import { ParcelTrackingEnrouteViewPage } from "./pages/delivery-management/parcel-tracking/parcel-tracking-view/enroute-view";
import { ParcelTrackingBatchesViewPage } from "./pages/delivery-management/parcel-tracking/parcel-tracking-view/batches-view";
import { ParcelTrackingBoxesViewPage } from "./pages/delivery-management/parcel-tracking/parcel-tracking-view/boxes-view";
import { ParcelTrackingTrolleyViewPage } from "./pages/delivery-management/parcel-tracking/parcel-tracking-view/trolley-view";
import { DeliveryFullscreenPage } from "./pages/delivery-management/parcel-tracking/parcel-tracking-view/delivery-fullscreen-view";
import { DeliveryReportPage } from "./pages/delivery-management/delivery-report";
import { IncidentReportListing } from "./pages/incident-report/incident-report-listing";
import { IncidentReportDetails } from "./pages/incident-report/incident-report-details";
import { AlgorithmInterfacePage } from "./pages/delivery-management/algo-interface";
import { ControlTower } from "./pages/delivery-management/control-tower";
import UpdateProfilePage from "./pages/profile/update-profile-page";
import PasswordForm from "Components/profile/profile-details/change-passwords/change-password";
import PlanSchedule from "./pages/order-management/order-processing/plan-schedule/plan-schedule";
import AllOrders from "./pages/order-management/order-processing/all-orders/all-orders";
import ConfigurationView from "./pages/fullscreen-view/configuration-view/configuration-view";
import LogisticsView from "./pages/fullscreen-view/logistics-view/logistics-view";
import PublicFullscreen from "./pages/fullscreen-view/public-view/public-fullscreen";
import data from "Hooks/access-control.hook/acl.json";
import { map, find, union } from "lodash";

interface Permission {
  identity: string;
  rights: string[];
  active: boolean;
  relatedOnly?: boolean;
}

const isActive = (
  roleTypes: string[],
  resource: string,
  permissionType: string,
) => {
  const permissions = (data.acl[resource] || {}).permissions || [];
  let permissionRights: Array<string> = [];

  map(roleTypes, (roleType) => {
    const userPermission = find(permissions, (permission: Permission) => {
      return permission.active && permission.identity === roleType;
    });

    // UNION of all roles' access
    permissionRights = union(permissionRights, userPermission?.rights || []);
  });

  return permissionRights.includes(permissionType);
};

const publicRoutes = [
  {
    path: "/login",
    exact: true,
    component: <Login />,
    isActive: true,
  },
  {
    path: "/forget-password",
    exact: true,
    component: <ForgotPassword />,
    isActive: true,
  },
  {
    path: "/verify-email",
    exact: true,
    component: <VerifyEmailPage />,
    isActive: true,
  },
  {
    path: "/verify-account",
    exact: true,
    component: <VerifyAccountPage />,
    isActive: true,
  },
  {
    path: "/verify-driver-account",
    exact: true,
    component: <VerifyAccountPage />,
    isActive: true,
  },
  {
    path: "/verify-driver-email-update",
    exact: true,
    component: <VerifyAccountPage />,
    isActive: true,
  },
  {
    path: "/resend-verify-email",
    exact: true,
    component: <ResendVerifyEmailPage />,
    isActive: true,
  },
  {
    path: "/reset-password",
    exact: true,
    component: <ResetPasswordPage />,
    isActive: true,
  },
  {
    path: "/track-trace",
    exact: true,
    component: <TrackNTrace />,
    isActive: true,
  },
  {
    path: "/public/:name/:id",
    exact: true,
    component: <PublicFullscreen />,
    isActive: true,
  },
  /*{
    path: '/products/supplier/:id',
    exact: true,
    component: <Product.ProductSupplierPage/>,
    withLayout: true,
    isActive: true
  },*/
];

const protectedRoutes = [
  {
    path: "/overview",
    exact: true,
    component: <div></div>,
    isActive: true,
  },
  {
    path: "/accounts",
    exact: true,
    component: <AccountListingPageNew />,
    isActive: true,
  },
  {
    path: "/accounts/create",
    exact: true,
    component: <AccountCreate />,
    isActive: true,
  },
  {
    path: "/customer-management/profile",
    exact: true,
    component: <CustomerProfilePage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Management", "LIST"),
  },
  {
    path: "/customer-management/profile/create",
    exact: true,
    component: <CustomerCreatePage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Management", "CREATE"),
  },
  {
    path: "/customer-management/profile/create/individual",
    exact: true,
    component: <CustomerCreatePage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Management", "CREATE"),
  },
  {
    path: "/customer-management/profile/create/company",
    exact: true,
    component: <CustomerCreatePage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Management", "CREATE"),
  },
  {
    path: "/customer-management/profile/edit/individual/:id",
    exact: true,
    component: <CustomerEditPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Management", "UPDATE"),
  },
  {
    path: "/customer-management/profile/edit/company/:id",
    exact: true,
    component: <CustomerEditPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Management", "UPDATE"),
  },
  {
    path: "/customer-management/profile/:id/view",
    exact: true,
    component: <CustomerProfilePage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Management", "VIEW"),
  },
  {
    path: "/customer-management/profile/create/success/:id",
    exact: true,
    component: <CustomerCreateSuccessPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Management", "CREATE"),
  },
  {
    path: "/customer-management/profile/deleted",
    exact: true,
    component: <DeletedCustomerProfilePage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Management", "VIEW"),
  },
  {
    path: "/customer-management/location",
    exact: true,
    component: <CustomerLocationPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Location_Management", "LIST"),
  },
  {
    path: "/customer-management/location/create",
    exact: true,
    component: <CustomerLocationPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Location_Management", "CREATE"),
  },
  {
    path: "/customer-management/location/:id/view",
    exact: true,
    component: <CustomerLocationPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Location_Management", "VIEW"),
  },
  {
    path: "/customer-management/location/:id/edit",
    exact: true,
    component: <CustomerLocationPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Location_Management", "UPDATE"),
  },
  {
    path: "/customer-management/location/deleted",
    exact: true,
    component: <CustomerLocationPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Customer_Location_Management", "VIEW"),
  },
  {
    path: "/driver-management/driver/create/success/:id",
    exact: true,
    component: <DriverCreationSuccessPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Rider_Management", "VIEW"),
  },
  // {
  //   path: '/driver-management/driver/track',
  //   exact: true,
  //   component: <DriverTrackPage />,
  //   isActive: true,
  // },
  {
    path: "/driver-management/driver/create",
    exact: true,
    component: <DriverCreationPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Rider_Management", "CREATE"),
  },
  // TODO: remove this page when external drivers is no longer created using internal platform
  {
    path: "/driver-management/driver/create/external",
    exact: true,
    component: <ExternalDriverCreationPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Rider_Management", "CREATE"),
  },
  {
    path: "/driver-management/driver",
    exact: true,
    component: <ActiveDriverListingPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Rider_Management", "LIST"),
  },
  {
    path: "/driver-management/driver/:formType/:id/edit",
    exact: true,
    component: <DriverUpdatePage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Rider_Management", "UPDATE"),
  },
  {
    path: "/driver-management/driver/:id/profile",
    exact: true,
    component: <ActiveDriverListingPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Rider_Management", "VIEW"),
  },
  {
    path: "/driver-management/driver/deleted",
    exact: true,
    component: <InactiveDriverListingPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Rider_Management", "VIEW"),
  },
  {
    path: "/driver-management/driver/deleted/:id/view",
    exact: true,
    component: <InactiveDriverListingPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Rider_Management", "VIEW"),
  },
  {
    path: "/order-management/settings",
    exact: true,
    component: <OrderProcessingSettings />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "LIST"),
  },
  {
    path: "/order-management/settings/form/:type",
    exact: true,
    component: <OrderProcessingSettingsForm />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "VIEW"),
  },
  {
    path: "/order-management/settings/form/:type/:id/edit",
    exact: true,
    component: <OrderProcessingSettingsEditForm />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "UPDATE"),
  },
  {
    path: "/order-management/customer/:id/settings",
    exact: true,
    component: <CustomerOrderSetting />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "VIEW"),
  },
  {
    path: "/order-management/customer/:id/settings/form/:type/:id/edit",
    exact: true,
    component: <CustomerOrderProcessingSettingsEditForm />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "UPDATE"),
  },
  {
    path: "/order-management/plan-schedule",
    exact: true,
    component: <PlanSchedule />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management_Plan_Schedule", "LIST"),
  },
  {
    path: "/order-management/all",
    exact: true,
    component: <AllOrders />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "LIST"),
  },
  // TODO rename all under this module to /order-processing/...
  {
    path: "/parcels-order-processing/parcels",
    exact: true,
    component: <ParcelsOrder />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "LIST"),
  },
  {
    path: "/parcels-order-processing/parcels/create",
    exact: true,
    component: <ParcelOrderCreationPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "CREATE"),
  },
  {
    path: "/parcels-order-processing/parcels/upload-mass-order",
    exact: true,
    component: <UploadMassOrderPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "LIST"),
  },
  {
    path: "/parcels-order-processing/parcels/:id/view",
    exact: true,
    component: <ParcelOrderViewPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "LIST"),
  },
  {
    path: "/parcels-order-processing/parcels/:id/edit",
    exact: true,
    component: <ParcelOrderEditPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "UPDATE"),
  },
  {
    path: "/parcels-order-processing/reporting",
    exact: true,
    component: <ReportOrders />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "LIST"),
  },
  {
    path: "/delivery-management/settings/assets",
    exact: true,
    component: <DeliveryAssetsListPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "LIST"),
  },
  {
    path: "/delivery-management/settings/assets/form/:type",
    exact: true,
    component: <DeliveryAssetsFormPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "VIEW"),
  },
  {
    path: "/delivery-management/settings/lines",
    exact: true,
    component: <DeliveryLinesListPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "LIST"),
  },
  {
    path: "/delivery-management/settings/lines/form",
    exact: true,
    component: <DeliveryLinesFormPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "VIEW"),
  },
  {
    path: "/delivery-management/settings/service-points",
    exact: true,
    component: <ServicePointsListPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "LIST"),
  },
  {
    path: "/delivery-management/settings/service-points/form/:type",
    exact: true,
    component: <ServicePointsFormPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "VIEW"),
  },
  {
    path: "/delivery-management/parcel-tracking",
    exact: true,
    component: <ParcelTracking />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "LIST"),
  },
  {
    path: "/delivery-management/parcel-tracking/pickup/:id/view",
    exact: true,
    component: <ParcelTrackingPickupViewPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "VIEW"),
  },
  {
    path: "/delivery-management/parcel-tracking/dropoff/:id/view",
    exact: true,
    component: <ParcelTrackingDropoffViewPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "VIEW"),
  },
  {
    path: "/delivery-management/parcel-tracking/enroute/:id/view",
    exact: true,
    component: <ParcelTrackingEnrouteViewPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "VIEW"),
  },
  {
    path: "/delivery-management/parcel-tracking/batches/:id/view",
    exact: true,
    component: <ParcelTrackingBatchesViewPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "VIEW"),
  },
  {
    path: "/delivery-management/parcel-tracking/boxes/:id/view",
    exact: true,
    component: <ParcelTrackingBoxesViewPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "VIEW"),
  },
  {
    path: "/delivery-management/parcel-tracking/trolley/:id/view",
    exact: true,
    component: <ParcelTrackingTrolleyViewPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "VIEW"),
  },
  {
    path: "/delivery-management/parcel-tracking/fullscreen",
    exact: true,
    component: <DeliveryFullscreenPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "VIEW"),
  },
  {
    path: "/incident-reports/report",
    exact: true,
    component: <IncidentReportListing />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "LIST"),
  },
  {
    path: "/delivery-management/report",
    exact: true,
    component: <DeliveryReportPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "LIST"),
  },
  {
    path: "/delivery-management/control-tower",
    exact: true,
    component: <ControlTower />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management_Control_Tower", "LIST"),
  },
  // {
  //   path: '/delivery-management/parcel-tracking/fullscreen/trolley',
  //   exact: true,
  //   component: <TrolleyFullScreen/>,
  //   isActive: true,
  // },
  // {
  //   path: '/delivery-management/parcel-tracking/fullscreen/boxes',
  //   exact: true,
  //   component: <BoxesFullScreen/>,
  //   isActive: true,
  // },
  {
    path: "/routing-algo-interface",
    exact: true,
    component: <AlgorithmInterfacePage />,
    isActive: true,
  },
  {
    path: "/delivery-management/settings",
    exact: true,
    component: <IncidentReportListing />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "LIST"),
  },
  {
    path: "/incident-reports/details/:id/view",
    exact: true,
    component: <IncidentReportDetails />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Delivery_Management", "VIEW"),
  },
  {
    path: "/parcels-order-processing/reporting",
    exact: true,
    component: <ReportOrders />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "LIST"),
  },
  {
    path: "/user-management/users",
    exact: true,
    component: <ActiveUsersList />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "User_Management", "LIST"),
  },
  {
    path: "/user-management/users/inactive",
    exact: true,
    component: <InactiveUsersList />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "User_Management", "LIST"),
  },
  {
    path: "/user-management/user/create",
    exact: true,
    component: <UserCreationPage />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "User_Management", "CREATE"),
  },
  {
    path: "/user-management/user/:orgID/:id/profile",
    exact: true,
    component: <ActiveUsersList />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "User_Management", "VIEW"),
  },
  {
    path: "/user-management/user/deactivated/:orgID/:id/profile",
    exact: true,
    component: <InactiveUsersList />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "User_Management", "VIEW"),
  },
  {
    path: "/user-management/user/:formType/:id/:orgID/edit",
    exact: true,
    component: <UserUpdate />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "User_Management", "UPDATE"),
  },
  {
    path: "/settings/personal-info",
    exact: true,
    component: <UpdateProfilePage />,
    isActive: true,
  },
  {
    path: "/settings/change-password",
    exact: true,
    component: <PasswordForm />,
    isActive: true,
  },
  {
    path: "/fullscreen/configuration",
    exact: true,
    component: <ConfigurationView />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "LIST"),
  },
  {
    path: "/fullscreen/tracking",
    exact: true,
    component: <LogisticsView />,
    isActiveFunction: (roleTypesVal) =>
      isActive(roleTypesVal, "Order_Management", "LIST"),
  },
];

const routes = {
  public: publicRoutes,
  protected: protectedRoutes,
};

export default routes;
